import { render, staticRenderFns } from "./Burdened.vue?vue&type=template&id=4b6478b2&scoped=true&"
import script from "./Burdened.vue?vue&type=script&lang=js&"
export * from "./Burdened.vue?vue&type=script&lang=js&"
import style0 from "./Burdened.vue?vue&type=style&index=0&id=4b6478b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6478b2",
  null
  
)

export default component.exports